import React, {Suspense, lazy, useLayoutEffect} from "react";
import {BrowserRouter, Routes, Route} from "react-router-dom";
import Main from "./templates/Main";
import EmindFullPageLoader from "./components/EmindFullPageLoader";

import {ProtectedRoute} from "./middlewares/ProtectedRouter";
import axios from "axios";

axios.defaults.withCredentials = true;

const BoardList = lazy(() => import("./pages/BoardList"));
const BoardArchiveList = lazy(() => import("./pages/BoardArchiveList"));
const BoardArchive = lazy(() => import("./pages/BoardArchive"));
const Board = lazy(() => import("./pages/Board"));
const Page404 = lazy(() => import("./pages/Page404"));
const LoginForm = lazy(() => import("./pages/LoginForm"));
const Profile = lazy(() => import("./pages/Profile"));
const Ideas = lazy(() => import("./pages/Ideas/Index"));
const Idea = lazy(() => import("./pages/Ideas/Idea"));
const Logout = lazy(() => import("./pages/Logout"));
const NotificationsHistory = lazy(() => import("./pages/NotificationsHistory"));
const Faq = lazy(() => import("./pages/Faq"));
const FaqArticle = lazy(() => import("./pages/FaqArticle"));

function BootLoaderCleanup() {
    useLayoutEffect(() => {
        document.getElementById("boot-loader")?.remove();
    }, []);
    return null;
}

function App() {
    return (
            <BrowserRouter basename="/lk">
                <BootLoaderCleanup/>
                <Suspense fallback={<EmindFullPageLoader/>}>
                    <Routes>
                        <Route
                                path="/"
                                element={
                                    <ProtectedRoute>
                                        <Main>
                                            <BoardList/>
                                        </Main>
                                    </ProtectedRoute>
                                }
                        />

                        <Route
                                path="/board/:boardId"
                                element={
                                    <ProtectedRoute>
                                        <Main>
                                            <Board/>
                                        </Main>
                                    </ProtectedRoute>
                                }
                        />
                        <Route
                                path="/board/:boardId/archive"
                                element={
                                    <ProtectedRoute>
                                        <Main>
                                            <BoardArchive/>
                                        </Main>
                                    </ProtectedRoute>
                                }
                        />
                        <Route
                                path="/boards/archive"
                                element={
                                    <ProtectedRoute>
                                        <Main>
                                            <BoardArchiveList/>
                                        </Main>
                                    </ProtectedRoute>
                                }
                        />
                        <Route
                                path="/boards/archive/:boardId"
                                element={
                                    <ProtectedRoute>
                                        <Main>
                                            <BoardArchiveList/>
                                        </Main>
                                    </ProtectedRoute>
                                }
                        />
                        <Route
                                path="/boards/archive/:boardId/:listId"
                                element={
                                    <ProtectedRoute>
                                        <Main>
                                            <BoardArchiveList/>
                                        </Main>
                                    </ProtectedRoute>
                                }
                        />
                        <Route
                                path="/boards/archive/:boardId/:listId/:taskId"
                                element={
                                    <ProtectedRoute>
                                        <Main>
                                            <BoardArchiveList/>
                                        </Main>
                                    </ProtectedRoute>
                                }
                        />

                        <Route path="login" element={<LoginForm/>}/>
                        <Route path="logout" element={<Logout/>}/>

                        <Route
                                path="profile"
                                element={
                                    <ProtectedRoute>
                                        <Profile/>
                                    </ProtectedRoute>
                                }
                        />

                        <Route
                                path="/ideas"
                                element={
                                    <ProtectedRoute>
                                        <Ideas/>
                                    </ProtectedRoute>
                                }
                        />

                        <Route
                                path="/ideas/:tagName"
                                element={
                                    <ProtectedRoute>
                                        <Ideas/>
                                    </ProtectedRoute>
                                }
                        />

                        <Route
                                path="/ideas/idea/:ideaId"
                                element={
                                    <ProtectedRoute>
                                        <Idea/>
                                    </ProtectedRoute>
                                }
                        />

                        <Route
                                path="/notifications/history"
                                element={
                                    <ProtectedRoute>
                                        <Main>
                                            <NotificationsHistory/>
                                        </Main>
                                    </ProtectedRoute>
                                }
                        />

                        <Route
                                path="/faq"
                                element={
                                    <ProtectedRoute>
                                        <Main>
                                            <Faq/>
                                        </Main>
                                    </ProtectedRoute>
                                }
                        />
                        <Route
                                path="/faq/category/:categoryId"
                                element={
                                    <ProtectedRoute>
                                        <Main>
                                            <FaqArticle/>
                                        </Main>
                                    </ProtectedRoute>
                                }
                        />
                        <Route
                                path="/faq/section/:sectionId"
                                element={
                                    <ProtectedRoute>
                                        <Main>
                                            <FaqArticle/>
                                        </Main>
                                    </ProtectedRoute>
                                }
                        />
                        <Route
                                path="/faq/article/:articleId"
                                element={
                                    <ProtectedRoute>
                                        <Main>
                                            <FaqArticle/>
                                        </Main>
                                    </ProtectedRoute>
                                }
                        />

                        <Route path="*" element={<Page404/>}/>
                    </Routes>
                </Suspense>
            </BrowserRouter>
    );
}

export default App;
